import { NAMESPACE as GLOBAL_NAMESPACE } from '../../constants';
import constants from './constants';

const PREFIX = `${GLOBAL_NAMESPACE}/${constants.NAMESPACE}`;

const PRESETS_FETCH_APPS_BY_FILE_IDS = `${PREFIX}/FETCH_APPS_BY_FILE_IDS` as const;
const PRESETS_FETCH = `${PREFIX}/FETCH` as const;
const PRESETS_FETCH_FILES = `${PREFIX}/FETCH_FILES` as const;
const PRESETS_GET_WITH_METADATA = `${PREFIX}/GET_WITH_METADATA` as const;
const PRESETS_POST = `${PREFIX}/POST` as const;
const PRESETS_PREPARE_AND_STORE_RECENT = `${PREFIX}/PREPARE_AND_STORE_RECENT` as const;

export default {
  PRESETS_FETCH_APPS_BY_FILE_IDS,
  PRESETS_GET_WITH_METADATA,
  PRESETS_FETCH,
  PRESETS_FETCH_FILES,
  PRESETS_POST,
  PRESETS_PREPARE_AND_STORE_RECENT,
};
